module.exports = __webpack_public_path__ + "static/media/01-github.109b65f8.svg";